// Should be updated whenever the structure of an aggregate changes.
// Changing this will cause aggregate snapshots to be discarded and rebuilt.
export const model = 2;
